module.exports = __webpack_public_path__ + "static/media/spinner-button.75baa3ed.gif";